module.exports = __webpack_public_path__ + "static/media/Artboard8.d1dd913e.png";